module.exports = __webpack_public_path__ + "static/media/RESTOS.52bf649d.png";